'use strict';

const Enum = require('./enum');

/**
 * @const {number}
 * Pin minimum value.
 */
const PIN_NUMBER_MIN = 1000;

/**
 * @const {number}
 * Pin maximum value.
 */
const PIN_NUMBER_MAX = 99999999999999;

/**
 * @const {number}
 * Pin minimum length.
 */
const PIN_LEN_MIN = PIN_NUMBER_MIN.toString().length;

/**
 * @const {number}
 * Pin maximum length.
 */
const PIN_LEN_MAX = PIN_NUMBER_MAX.toString().length;

/**
 * @const {number}
 * Maximum amount of seconds allowed
 * for access time value (when
 * described in seconds)
 */
const PIN_ACCESS_TIME_SEC_MAX = 60 * 60 * 24 - 1;

/**
 * Defines states around pin
 * sync commands.
 *
 * @enum
 * @readonly
 */
const PinSynTransactionStates = Object.create(Enum, {
  INIT: { value: 'init', enumerable: true },
  USER_MAPPED: { value: 'userMapped', enumerable: true },
  USER_MAPPED_FAILED: { value: 'userMappedFailed', enumerable: true },
  INTENT: { value: 'intent', enumerable: true },
  INTENT_FAILED: { value: 'intentFailed', enumerable: true },
  COMMIT: { value: 'commit', enumerable: true },
  COMMIT_FAILED: { value: 'commitFailed', enumerable: true },
  RETRY_SCHEDULED: { value: 'retryScheduled', enumerable: true },
  RETRY_SCHEDULED_FAILED: { value: 'retryScheduledFailed', enumerable: true },
  DONE: { value: 'done', enumerable: true },
});

/**
 * Defines actions around pin
 * sync commands.
 *
 * @enum
 * @readonly
 */
const PinSynCommandActions = Object.create(Enum, {
  LOAD: { value: 'load', enumerable: true },
  DELETE: { value: 'delete', enumerable: true },
  DISABLE: { value: 'disable', enumerable: true },
  ENABLE: { value: 'enable', enumerable: true },
  UPDATE: { value: 'update', enumerable: true },
});

/**
 * Defines stats of pins.
 *
 * @enum
 * @readonly
 */
const PinStates = Object.create(Enum, {
  CREATED: { value: 'created', enumerable: true },
  LOADED: { value: 'loaded', enumerable: true },
  DISABLED: { value: 'disabled', enumerable: true },
  DISABLING: { value: 'disabling', enumerable: true },
  ENABLING: { value: 'enabling', enumerable: true },
  DELETING: { value: 'deleting', enumerable: true },
  UPDATING: { value: 'updating', enumerable: true },
});

/**
 * Defines pin access types
 *
 * @enum
 * @readonly
 */
const PinAccessTypes = Object.create(Enum, {
  ALWAYS: { value: 'always', enumerable: true },
  RECURRING: { value: 'recurring', enumerable: true },
  TEMPORARY: { value: 'temporary', enumerable: true },
  ONE_TIME: { value: 'onetime', enumerable: true },
});

/**
 * Defines keys for pin access times
 * date ranges.
 *
 * @enum
 * @readonly
 */
const PinAccessTimeKeys = Object.create(Enum, {
  START_SEC: { value: 'STARTSEC', enumerable: true },
  END_SEC: { value: 'ENDSEC', enumerable: true },
  START_ISO: { value: 'DTSTART', enumerable: true },
  END_ISO: { value: 'DTEND', enumerable: true },
  toTemplateISOString: {
    value: function() {
      return this.START_ISO + '=' + '%s;' + this.END_ISO + '=' + '%s';
    },
    enumerable: false,
  },
  toTemplateString: {
    value: function() {
      return this.START_SEC + '=' + '%d;' + this.END_SEC + '=' + '%d';
    },
    enumerable: false,
  },
});

const PinPayloadStatuses = Object.create(Enum, {
  CONFLICT: { value: 'conflict', enumerable: true },
  FAILURE: { value: 'failure', enumerable: true },
  SUCCESS: { value: 'success', enumerable: true },
});

exports.PIN_NUMBER_MIN = PIN_NUMBER_MIN;
exports.PIN_NUMBER_MAX = PIN_NUMBER_MAX;
exports.PIN_LEN_MIN = PIN_LEN_MIN;
exports.PIN_LEN_MAX = PIN_LEN_MAX;
exports.PIN_ACCESS_TIME_SEC_MAX = PIN_ACCESS_TIME_SEC_MAX;

exports.PinSynTransactionStates = PinSynTransactionStates;
exports.PinSynCommandActions = PinSynCommandActions;
exports.PinStates = PinStates;
exports.PinAccessTypes = PinAccessTypes;
exports.PinAccessTimeKeys = PinAccessTimeKeys;
exports.PinPayloadStatuses = PinPayloadStatuses;
